<template>
  <div class="columns mb-4">
    <div class="column level-left" style="padding-top:0px">
      <p style="margin-bottom:1rem;"><strong>{{title}}</strong></p>
      <p>{{body}}</p>
    </div>
    <div class=" level-right">
      <img :src="require('@/assets/' + image + '')" style="margin-left:2rem;max-width:250px;max-height:250px;">
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutDetail',
  props:{
    title: String,
    body: String,
    image: String
  },
  data () {
    return {
    }
  },
  methods: {  }
}
</script>